import React, {useEffect, useState} from "react";
import Utils from "../../utils/Utils";
import "../../css/button.css"
import api from "../../utils/axios";

const Submissions = () => {
    const [messages, setMessages] = useState([]);
    const [filter, setFilter] = useState("all");
    const [loading, setLoading] = useState(false);
    const [replyModalOpen, setReplyModalOpen] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [replySubject, setReplySubject] = useState("");
    const [replyBody, setReplyBody] = useState("");
    const [sendingReply, setSendingReply] = useState(false);

    const loadMessages = async () => {
        try {
            setLoading(true);

            const res = await api.get("/admin/contact-messages");
            console.log(res.data);
            setMessages(res.data.messages || []);
        } catch (err) {
            console.error(err);
            alert(err.response?.data?.error || "Failed to load contact messages");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        loadMessages();
        }, []);

    function formatDate(value) {
        if (!value) return "-";
        return new Date(value).toLocaleString("en-GB", {
            dateStyle: "short",
            timeStyle: "short",
        });
    }

    const openReplyModal = (msg) => {
        setSelectedMessage(msg);
        setReplySubject(`Re: Contact message from ${msg.name}`);
        setReplyBody("");
        setReplyModalOpen(true);
    };

    const sendReply = async () => {
        if (!replySubject.trim() || !replyBody.trim()) {
            alert("Subject and message are required");
            return;
        }

        try {
            setSendingReply(true);

            await api.post(`/admin/contact-messages/${selectedMessage.id}/reply`, {
                subject: replySubject,
                message: replyBody,
            });

            setReplyModalOpen(false);
            setSelectedMessage(null);
            setReplySubject("");
            setReplyBody("");

            await loadMessages();
        } catch (err) {
            console.error(err);
            alert(err.response?.data?.error || "Failed to send reply");
        } finally {
            setSendingReply(false);
        }
    };

    const overlayStyle = {
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
    };

    const modalStyle = {
        background: "white",
        padding: "25px",
        borderRadius: "8px",
        width: "600px",
        maxHeight: "85vh",
        overflowY: "auto",
    };


    const markAsReplied = async (id) => {
        try {
            await api.patch(`/admin/contact-messages/${id}/replied`);
            await loadMessages();
        } catch (err) {
            console.error(err);
            alert(err.response?.data?.error || "Failed to update message");
        }
    };

    const filteredMessages = messages.filter((msg) => {
        if (filter === "replied") return msg.replied;
        if (filter === "not_replied") return !msg.replied;
        return true;
    });


    return (
        <div style={{marginBottom:'30px'}}>
            <div>
                <h2 align={"center"}>User Form Submissions</h2>
            </div>
            <div style={{ marginBottom: "15px" }}>
                <label>Filter:
                    <select value={filter} name={"filter"} onChange={(e) => setFilter(e.target.value)}>
                        <option value="all">All</option>
                        <option value="not_replied">Not replied</option>
                        <option value="replied">Replied</option>
                    </select>
                </label>

                <span style={{ marginLeft: "15px" }}>
                    Total: {filteredMessages.length}
                </span>
            </div>

            {loading ? (
                <p>Loading messages...</p>
            ) : (
                <table
                    cellPadding="8"
                    style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        border: "1px solid #ccc",
                    }}
                >
                    <thead>
                    <tr style={{ backgroundColor: "#f2f2f2" }}>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Message</th>
                        <th>Created At</th>
                        <th>Replied</th>
                        <th>Replied At</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {filteredMessages.map((msg) => (
                        <tr key={msg.id}>
                            <td>{msg.id}</td>
                            <td>{msg.name}</td>
                            <td>
                                <a href={`mailto:${msg.email}`}>{msg.email}</a>
                            </td>
                            <td style={{ maxWidth: "300px", whiteSpace: "pre-wrap" }}>
                                {msg.message}
                            </td>
                            <td>{formatDate(msg.created_at)}</td>
                            <td>{msg.replied ? "Yes" : "No"}</td>
                            <td>{msg.replied_at ? formatDate(msg.replied_at) : "-"}</td>
                            <td>
                                {!msg.replied ? (
                                    <span
                                        onClick={() => openReplyModal(msg)}
                                        style={{
                                            color: "blue",
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Reply
                                    </span>
                                ) : (
                                    "Replied"
                                )}
                            </td>
                        </tr>
                    ))}

                    {filteredMessages.length === 0 && (
                        <tr>
                            <td colSpan="8" style={{ textAlign: "center" }}>
                                No messages found
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            )}
            {replyModalOpen && selectedMessage && (
                <div style={overlayStyle}>
                    <div style={modalStyle}>
                        <h3>Reply to {selectedMessage.name}</h3>
                        <p>
                            <strong>Email:</strong> {selectedMessage.email}
                        </p>

                        <p>
                            <strong>Original message:</strong>
                        </p>
                        <div
                            style={{
                                background: "#f5f5f5",
                                padding: "10px",
                                marginBottom: "10px",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            {selectedMessage.message}
                        </div>
                        <label>Subject
                            <input
                                name={"subject"}
                                value={replySubject}
                                onChange={(e) => setReplySubject(e.target.value)}
                                style={{ width: "100%", marginBottom: "10px" }}
                            />
                        </label>
                        <label>Reply message
                            <textarea
                                name={"message"}
                                value={replyBody}
                                onChange={(e) => setReplyBody(e.target.value)}
                                rows={8}
                                style={{ width: "100%", marginBottom: "10px" }}
                            />
                        </label>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <button onClick={sendReply} disabled={sendingReply}>
                                {sendingReply ? "Sending..." : "Send reply"}
                            </button>
                            <button
                                onClick={() => {
                                    setReplyModalOpen(false);
                                    setSelectedMessage(null);
                                }}
                                disabled={sendingReply}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Submissions